import * as styles from './GeoSuggestLayout.css';

export const GeoSuggestLayout: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};
